import React from 'react';

const EyeVisibleIcon = () => {
  return (
<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 4.8C10.7233 4.8 11.417 5.13714 11.9285 5.73726C12.4399 6.33737 12.7273 7.15131 12.7273 8C12.7273 8.84869 12.4399 9.66263 11.9285 10.2627C11.417 10.8629 10.7233 11.2 10 11.2C9.27668 11.2 8.58299 10.8629 8.07153 10.2627C7.56006 9.66263 7.27273 8.84869 7.27273 8C7.27273 7.15131 7.56006 6.33737 8.07153 5.73726C8.58299 5.13714 9.27668 4.8 10 4.8ZM10 0C14.5455 0 18.4273 3.31733 20 8C18.4273 12.6827 14.5455 16 10 16C5.45455 16 1.57273 12.6827 0 8C1.57273 3.31733 5.45455 0 10 0ZM1.98182 8C3.48182 11.584 6.58182 13.8667 10 13.8667C13.4182 13.8667 16.5182 11.584 18.0182 8C16.5182 4.416 13.4182 2.13333 10 2.13333C6.58182 2.13333 3.48182 4.416 1.98182 8Z" fill="#C3C3C3"/>
</svg>



  );
};

export default EyeVisibleIcon;